<style lang="stylus">
    .mvpage-box
        max-height 300px
        overflow-y scroll
        overflow overlay
</style>

<template>
    <div class="mvpage-box">
        <div class="menu-item" @click="sendToNewPages(-1)">{{ $t("newpage") }}</div>
        <div
            class="menu-item"
            v-for="(item, index) in pageNames"
            v-if="index != activedPageIndex"
            @click="sendToNewPages(index)"
            v-text="item.name"
        ></div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component({})
    export default class mvLayer extends Vue {
        get pageNames() {
            return this.$store.state.page.pages;
        }
        get activedPageIndex() {
            return this.$store.state.page.activedPageIndex;
        }
        closeContext() {
            this.$store.commit("closeContext");
        }
        sendToNewPages(index) {
            window["_view"].sendToNewPage(index);
            if (!this.vip && this.$store.state.page.pages && this.$store.state.page.pages.length >= 2) {
                this.sensors.track("tryVipBenefit", {
                    Catalogues: "editFileProcess",
                    trial_vip_benefit: "pageIcon",
                });
            }
            this.closeContext();
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "newpage": "新页面"
  },
  "en": {
    "newpage": "New Page"
  },
  "de": {
    "newpage": "Neue Seite"
  },
  "fr": {
    "newpage": "Nouvelle page"
  },
  "jp": {
    "newpage": "新しいページ"
  },
  "es": {
    "newpage": "Nueva pagina"
  },
  "it": {
    "newpage": "Nuova pagina"
  },
  "pt": {
    "newpage": "Nova página"
  },
  "tw": {
    "newpage": "新頁面"
  }
}
</i18n>
